import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { LicenseStatus } from '../api/license';

// Re-exported for existing consumers (LicenseWarningBanner.tsx, AppSidebar.tsx)
// that import LicenseStatus from this module — GitLab #129 code-review
// follow-up: this used to be a SECOND, drifted-apart definition of the same
// type; the canonical one now lives in ../api/license.
export type { LicenseStatus };

export const useLicenseStatus = () => {
  return useQuery<LicenseStatus>({
    queryKey: ['license-status'],
    queryFn: async () => {
      const response = await api.get('/admin/license');
      return (response.data.data ?? response.data) as LicenseStatus;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    // Повторять только то, что имеет шанс получиться (#325).
    //
    // По умолчанию react-query делает три повтора на ЛЮБУЮ ошибку. Пока
    // сервер отвечал на этот запрос `400 Unknown resource`, каждая загрузка
    // страницы давала 2–4 одинаковых обречённых запроса — отказ 4xx означает
    // «так и будет», сколько ни повторяй.
    //
    // 5xx и сетевой сбой — другое дело: они бывают временными, поэтому один
    // повтор остаётся. Ошибка без ответа (обрыв соединения) считается
    // повторяемой.
    retry: (failureCount, error: unknown) => {
      const status = (error as { response?: { status?: number } })?.response?.status;
      if (status !== undefined && status >= 400 && status < 500) {
        return false;
      }
      return failureCount < 1;
    },
  });
};
